
    export const BRANDING_COLOR = "#c52036"
    export const SIGNATURE_THRESHOLD_AMOUNT = undefined
    export const USE_RICH_CHECKOUT = "true"
    export const RICH_CHECKOUT_DEEPLINK_SCHEMA = "https://senators.ordernext.com/"
    export const RICH_CHECKOUT_TEXT_PROMPT = "To pay with Virtual Currency or Loaded Value, scan the QR code and complete the order."
    export const PUSHER_KEY = "1a713dd51f69a0de4b4b"
    export const PUSHER_CLUSTER = "us2"
    export const TEAM_LOGO_EXISTS = false
    export const PRINTING_ENABLED = false
    export const CLOUDINARY_NAME = 'venuenext'
    export const CLOUDINARY_PRESET_NAME = 'venuenext'
  